<template>
  <v-app id="searchEign">
    <v-main>
      <v-container fluid class="mt-3" v-show="showParameters">
        <v-row class="mx-2">
          <v-col cols="2">
            <v-text-field v-model="eign_code" label="Host ID" @keyup.enter="getHosts"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode" item-text="bedrCode" label="Company" multiple></v-select>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="2">
            <v-text-field v-model="eign_naam" label="Host lastname or companyname" hint="Use of wildcards (*<input>*) supported. Searches lastname and companyname" @keyup.enter="getHosts" autocomplete="new-host-naam"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field v-model="eign_email" label="Host email" hint="Use of wildcards (*<input>*) supported. Searches both e-mail addresses" @keyup.enter="getHosts" autocomplete="new-host-email"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="2">
            <v-text-field v-model="eign_tel" label="Host telephone" hint="Use of wildcards (*<input>*) supported. Searches all three phonenumbers" @keyup.enter="getHosts" autocomplete="new-host-telephone"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="5">
            <m_select_gebr_codes label="Agent(s)" field="gebrCodesSelected" @updateData="updateData"
              :selected_gebrcodes="gebrCodesSelected" :localStorageItem="localStorageItemGebr" :isAgent="true"
              :canSelectAll="true" :isClearable="true" :isSearchable="true" :isMultiple="true" :isDense="false"
              :visibleChips="8" />
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="1" span="2" style="display: flex; flex-direction: row; gap: 20px;">
            <v-btn class="warning ma-0" small @click="parametersShow()" v-if="showClearButton"><v-icon left>mdi-refresh</v-icon>Clear</v-btn>
            <v-btn class="primary ma-0" small @click="getHosts()"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
            <v-btn v-if="filteredItems.length > 0" class="primary ma-0" small @click="showParameters = false"><v-icon left>mdi-eye-off-outline</v-icon>Hide parameters</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-btn v-show="!showParameters" class="primary ma-0" small @click="parametersShow()"><v-icon left>mdi-eye-outline</v-icon>Show parameters</v-btn>
        <div v-if="results">
          <v-card flat class="px-2">
            <v-text-field v-model="search" label="Search in results" single-line hide-details prepend-icon="mdi-magnify"></v-text-field>
            <v-data-table :items="filteredItems" :headers="headers" hide-default-footer :search="search"
              :items-per-page="getRowsPerPage()" :page.sync="page" no-data-text="No guest(s) to display"
              loading-text="Loading data...please wait" :loading="loading">
              <template v-slot:item="props">
                <tr>
                  <td @click="$router.open('/eign/onEign/' + props.item.eign_encrid)"><a> {{ props.item.eign_code }} </a></td>
                  <td style="max-width: 200px;">{{ props.item.eign_voornaam }}</td>
                  <td style="max-width: 250px;">{{ props.item.eign_naam }}</td>
                  <td style="max-width: 300px;">{{ props.item.eign_bedrijfsnaam }}</td>
                  <td>{{ props.item.eign_mail }}</td>
                  <td>{{ props.item.eign_mail_extra }}</td>
                  <td>{{ props.item.eign_tel1_vcs }}</td>
                  <td>{{ props.item.eign_tel2_vcs }}</td>
                  <td>{{ props.item.eign_tel3_vcs }}</td>
                  <td>{{ props.item.eign_bedr_code }}</td>
                  <td>{{ props.item.eign_gebr_code }}</td>
                </tr>
              </template>
            </v-data-table>
            <div v-if="!loading && items.length > 0"
              style="display: flex; align-items: center; justify-content :end; margin-top: 20px; font-size: small; color:grey;">
              <v-btn icon @click="goToFirstPage" :disabled="page === 1"><v-icon>mdi-chevron-double-left</v-icon></v-btn>
              <v-btn icon @click="goToPreviousPage" :disabled="page === 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
              <div style="display: flex; justify-content: center; align-items: center; margin-left: 15px; margin-right: 15px; min-width: 80px;">Page {{ page }} of {{ lastPage }}</div>
              <v-btn icon @click="goToNextPage" :disabled="page === lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
              <v-btn icon @click="goToLastPage" :disabled="page === lastPage"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
              <div style="margin-left: 15px; min-width: 150px;">Record {{ startRecord }}-{{ eindRecord }} of {{ this.filteredItems.length }}</div>
            </div>
          </v-card>
        </div>
      </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main" />
    <standard_dialog ref="standard_dialog" @standard_dialog_close="parametersShow(false)" />
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import m_select_gebr_codes from "@/components/ui/selectors/m_select_gebr.vue"
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
  components: {
    navBar,
    m_select_gebr_codes,
    standard_dialog
  },
  data() {
    return {
      results: false,
      showParameters: true,
      statCodesSelected: [],
      statCodes: [],
      gebrCodesSelected: [],
      gebrCodes: [],
      bedrCodesSelected: [],
      bedrCodes: [],
      items: [],
      eign_code: '',
      eign_naam: '',
      eign_email: '',
      eign_tel: '',
      param: {},
      search: '',
      loading: false,
      page: 1,
      showClearButton: false,
      localStorageItemGebr: 'list.searcheign.gebrcodes',
      headers: [
        { text: 'Id', value: 'eign_code' },
        { text: 'Name', value: 'eign_voornaam' },
        { text: 'Surname', value: 'eign_naam' },
        { text: 'Company name', value: 'eign_bedrijfsnaam' },
        { text: 'E-mail', value: 'eign_mail' },
        { text: 'E-mail (extra)', value: 'eign_mail_extra' },
        { text: 'Tel.', value: 'eign_tel1_vcs' },
        { text: 'Tel. 2', value: 'eign_tel2_vcs' },
        { text: 'Tel. 3', value: 'eign_tel3_vcs' },
        { text: 'Co.', value: 'eign_bedr_code' },
        { text: 'Agent', value: 'eign_gebr_code' },
      ]
    }
  },
  created() {
    this.parametersShow()
    this.$axios
      .post("ares/json/ares/eign/getSearchEignParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSearchEignParam"
        },
        getSearchEignParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          this.param = res.data.getSearchEignParam;          
          res.data.getSearchEignParam.bedrKeuzes.forEach(function (bedr) {
            this.bedrCodes.push(bedr.bedrCode);
            if (bedr.bedrSelected === true) {
              this.bedrCodesSelected.push(bedr.bedrCode);
            }
          }.bind(this));
        }
      });
  },
  computed: {
    lastPage() {
      return Math.ceil(this.filteredItems.length / this.getRowsPerPage());
    },
    startRecord() {
      return (this.page - 1) * this.getRowsPerPage() + 1;
    },
    eindRecord() {
      return Math.min(this.page * this.getRowsPerPage(), this.filteredItems.length);
    },
    filteredItems() {
      if (!this.search) {
        return this.items;
      }
      const lowerCaseSearch = this.search.toLowerCase();
      return this.items.filter(item =>
        item.eign_code.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_voornaam.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_naam.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_bedrijfsnaam.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_mail.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_mail_extra.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_tel1_vcs.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_tel2_vcs.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_tel3_vcs.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_bedr_code.toLowerCase().includes(lowerCaseSearch) ||
        item.eign_gebr_code.toLowerCase().includes(lowerCaseSearch)
      );
    },
  },
  methods: {
    goToFirstPage() {
      this.page = 1;
    },
    goToLastPage() {
      this.page = this.lastPage;
    },
    goToPreviousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    goToNextPage() {
      if (this.page < this.lastPage) {
        this.page++;
      }
    },
    getRowsPerPage() {
      return this.$vuetify.breakpoint.lgAndDown ? 9 : 13;
    },
    parametersShow(clearParams=true) {
      if(clearParams) {
        this.eign_code = '';
        this.eign_naam = '';
        this.eign_email = '';
        this.eign_tel = '';
      }
      this.showParameters = true;
      this.items = [];
      this.results = false;
      this.search = '';
    },
    updateData(data) {
      this[data.field] = data.value;
    },
    getHosts() {

      const index = this.gebrCodesSelected.indexOf('allAgents');
      if (index > -1) { // only splice array when item is found
        this.gebrCodesSelected.splice(index, 1); // 2nd parameter means remove one item only
      }

      this.results = true;
      this.showParameters = false;
      this.loading = true
      this.items = [];
      this.$axios
        .post("ares/json/ares/eign/searchEign2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchEign"
          },
          searchEign: {
            eign_code: this.eign_code,
            bedr_codes: this.bedrCodesSelected,
            gebr_codes: this.gebrCodesSelected,
            eign_email: this.eign_email,
            eign_naam: this.eign_naam,
            eign_tel: this.eign_tel
          }
        })
        .then(res => {
          if (res.data.error) {
            this.$refs.standard_dialog.setWidth(450);
            this.$refs.standard_dialog.setTextClass("text-center text-body-1 pa-3 pt-6");
            this.$refs.standard_dialog.open('warning', 'Warning', res.data.error.message);
            this.showClearButton = true
            this.loading = false;
          } else {
            this.items = res.data.searchEign;
            localStorage.setItem(this.localStorageItemGebr, this.gebrCodesSelected);
            this.showClearButton = false
            this.loading = false;
          }
        })
    },

  }
};

</script>
